module.exports = __webpack_public_path__ + "img/eye-outline-green.b4e5d75e.svg";